module.exports = __webpack_public_path__ + "static/media/download.01b13418.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dealroom-icons/download.svg
// module id = 1811
// module chunks = 0